@if (hasPoint) {
	<div class="map-frame" [class.dragging]="!!drag" [style.height.px]="height"
		(pointerdown)="onPanDown($event)" (pointermove)="onMove($event)"
		(pointerup)="onUp($event)" (pointercancel)="onUp($event)"
		(wheel)="onWheel($event)" (dblclick)="onDblClick($event)">
		@for (t of tiles; track t.key) {
			<img class="tile" [src]="t.url" [style.left.px]="t.left" [style.top.px]="t.top" alt="" loading="lazy" />
		}
		<!-- Épingle « goutte » déplaçable : la POINTE (15,40 du viewBox) tombe exactement sur les
		     coordonnées GPS (translate(-50%,-100%)). Un seul point => pas de numéro, point central. -->
		<div class="marker" [style.left.px]="markerLeft" [style.top.px]="markerTop" [title]="label"
			(pointerdown)="onMarkerDown($event)">
			<svg width="30" height="40" viewBox="0 0 30 40" aria-hidden="true">
				<path d="M15 40 C11 30.5 2.5 21.5 2.5 13 A12.5 12.5 0 1 1 27.5 13 C27.5 21.5 19 30.5 15 40 Z" fill="#d32f2f"/>
				<circle cx="15" cy="13" r="8.5" fill="#fff"/>
				<circle cx="15" cy="13" r="3" fill="#d32f2f"/>
			</svg>
		</div>
		<div class="map-zoom">
			<button type="button" mat-mini-fab (click)="zoomBy(1)" aria-label="Zoom avant"><mat-icon>add</mat-icon></button>
			<button type="button" mat-mini-fab (click)="zoomBy(-1)" aria-label="Zoom arrière"><mat-icon>remove</mat-icon></button>
			<button type="button" mat-mini-fab (click)="recenter()" title="Recentrer sur le marqueur" aria-label="Recentrer sur le marqueur"><mat-icon>filter_center_focus</mat-icon></button>
		</div>
		<div class="map-attrib">© OpenStreetMap</div>
	</div>
}
